import { Component, OnInit, OnDestroy, Input, HostListener } from '@angular/core';
import { ContextService, FullContext } from '@app/core/service/context.service';
import { AdvertisementService } from '@app/core/business/advertisement/advertisement.service';
import { Ad } from '@app/core/business/advertisement/ad';
import { Observable, interval, Subscription } from 'rxjs';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Address } from '@app/core/business/address';
import { ActivatedRoute } from '@angular/router';
import { environment } from '@env/environment';

@UntilDestroy()
@Component({
  selector: 'app-advertisement',
  templateUrl: './advertisement.component.html',
  styleUrls: ['./advertisement.component.scss'],
})
export class AdvertisementComponent implements OnInit, OnDestroy {
  private refresh: Subscription;

  @Input()
  public origin: string;

  public ad: Ad;
  public advertisements: Ad[];



  public advertisementsTemp: Ad[] = [];

  public visible = false;
  public environment = environment;
  public innerWidth: number;

  private companyCode: string;
  private customerCode: string;
  private deliveryAddresses: Address[] = [];
  public requestNbAd: number = 0;

  constructor(private contextService: ContextService, private adService: AdvertisementService, private route: ActivatedRoute) {}

  ngOnInit() {
    this.innerWidth = window.innerWidth;
    // Abonnement à fullContext pour détecter les changements de compagnies ou de clients
    this.contextService.fullContext$
      .pipe(untilDestroyed(this))
      .subscribe((context: FullContext) => {
        // Test si une compagnie est sélectionné
        if (!context.company) {
          this.visible = false;
          this.companyCode = null;
          this.customerCode = null;
          this.deliveryAddresses = [];

          // Désabonnement du refresh
          if (this.refresh) {
            this.refresh.unsubscribe();
          }
        }

        // Récupération de la liste des adresses de livraison
        if (context.customer) {
          this.customerCode = context.customer.code;
          this.deliveryAddresses = context.customer.deliveryAddresses;
        }

        if ((context.company && context.company.code !== this.companyCode)) {
          this.companyCode = context.company.code;

          if (context.company.settings)
            this.visible = context.company.settings.hasAdvertisement;

          // Unsubscribe on company change
          if (this.refresh) {
            this.refresh.unsubscribe();
          }

          if (this.visible) {
            // First request
            this.getNbAdWithInnerWidth();
            this.getAdvertisements()
              .pipe(untilDestroyed(this))
              .subscribe(ad => {
                this.advertisements = ad.filter(a => a.origin == this.origin);

                this.advertisementsTemp = JSON.parse(JSON.stringify(this.advertisements));
              });

            // If the refresh rate is different than 0, update ad each interval
            if (context.company.settings.advertisementRefreshRate > 0) {
              const rate = interval(context.company.settings.advertisementRefreshRate * 1000);

              // Abonnement pour refresh la publicité
              this.refresh = rate.subscribe(() => {
                this.getNbAdWithInnerWidth();
                this.getAdvertisements()
                  .pipe(untilDestroyed(this))
                  .subscribe(ad => {
                    this.advertisements = ad.filter(a => a.origin == this.origin);
                    this.advertisementsTemp = JSON.parse(JSON.stringify(this.advertisements));
                  });
              });
            }
          }
        }
      },
      () => {
        this.visible = false;
        this.companyCode = null;
        this.customerCode = null;
        this.deliveryAddresses = [];

        // Désabonnement du refresh
        if (this.refresh) {
          this.refresh.unsubscribe();
        }
      });
  }

  ngOnDestroy() {
    //this.refresh.unsubscribe();
  }

  /**
   * Récupération d'une publicité à afficher
   */
  private getAd(): Observable<Ad> {
    // Test si le client à un magasin par défaut afin de lui afficher une publicité "site"
    if (this.customerCode && this.deliveryAddresses.length > 0){
      const defaultDeliveryAddress = this.deliveryAddresses.find(da => da.defaultShippingAddress && da.defaultShippingAddress == 'Par défaut');
      if (defaultDeliveryAddress) {
        return this.adService.getAdvertisementByLocation(defaultDeliveryAddress.defaultDepartureLocation);
      }
    }

    return this.adService.getAdvertisement();
  }


  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.innerWidth = window.innerWidth;
    this.getNbAdWithInnerWidth();
  }

  /**
   * Récupération du nombre de publicité à afficher suivant la taille de l'écran
   */
  async getNbAdWithInnerWidth() {

      if (this.innerWidth <= 570) {
        this.requestNbAd = 1;
        this.advertisements = JSON.parse(JSON.stringify(this.advertisementsTemp));
        this.advertisements?.splice(1, 2);
      }
      else if (this.innerWidth > 570 && this.innerWidth <= 1280) {
        this.requestNbAd = 2;
        this.advertisements = JSON.parse(JSON.stringify(this.advertisementsTemp));
        this.advertisements?.splice(2, 1);
      }
      else {
        this.requestNbAd = 3;
        this.advertisements = JSON.parse(JSON.stringify(this.advertisementsTemp));
        this.advertisements?.splice(3, 1);
      }


    //await this.getAdvertisements();
  }

  /**
   * Récupération de plusieurs publicités à afficher
   */
  private getAdvertisements(): Observable<Ad[]> {
    return this.adService.getAdvertisements(this.origin, this.requestNbAd);
  }

  /**
   * Action lors du click sur une publicité
   */
  public handleClick(ad: Ad) {
    // Enregistrement du click sur la publicité
    this.adService.putAdvertisement(ad.code).subscribe();

    // Redirection vers l'url de la publicité
    if (ad.url) {
      window.open(ad.url);
    }
  }
}
